var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map-container"}},[_c('coordinates'),_vm._v(" "),_c('div',{staticClass:"map-tools-container",attrs:{"id":"v-step-4"}},[_c('colorbar'),_vm._v(" "),_c('layer-selections')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }